import { render, staticRenderFns } from "./DetailDemandeInstance.vue?vue&type=template&id=53d5df47&"
import script from "./DetailDemandeInstance.vue?vue&type=script&lang=js&"
export * from "./DetailDemandeInstance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports